<template>
  <v-app id="app">
    <v-main>
      <router-view />
    </v-main>
    <applicationFooter />
    <div id="progress-container"><div id="progress-item"></div></div>
  </v-app>
</template>

<script>
import Footer from "./components/frame/footer.vue";
import Api from "@/logic/api/api.js";
import Account from "@/logic/api/account.js";
import ValueMapper from "@/logic/common/value-mapper.js";

export default {
  components: {
    applicationFooter: Footer,
  },
  mounted() {
    // 初期値を設定する
    const DEFAULT_ATTRIBUTES = {
      "initial-scale": "1.0",
      width: 500,
    };
    /**
     * オブジェクトを別オブジェクトとしてコピーする
     */
    const copyObject = (object) => {
      return JSON.parse(JSON.stringify(object));
    };
    /**
     * 文字列を属性値に変換する
     */
    const stringToAttribute = (string) => {
      // 初期値を別オブジェクトとしてコピーする
      let result = copyObject(DEFAULT_ATTRIBUTES);
      try {
        string.split(",").forEach((item) => {
          const component = item.split("=");
          result[component[0]] = component[1];
        });
      } catch {
        result = copyObject(DEFAULT_ATTRIBUTES);
      }
      return result;
    };
    /**
     * 属性値を文字列に変換する
     */
    const attributeToString = (attributes) => {
      let result = [];
      Object.keys(attributes).forEach((key) => {
        result.push(`${key}=${attributes[key]}`);
      });
      return result.join(",");
    };
    // ビューポートを取得する
    const viewport = document.getElementById("main-viewport");
    let attributes = {};
    try {
      // index.htmlの設定値を参照する
      attributes = stringToAttribute(viewport.getAttribute("content"));
      // 実際の画面の幅と、viewportの幅から見た倍率を取得する
      const virtual_width = parseInt(attributes["width"]);
      const aspect =
        Math.min(window.parent.screen.width, window.parent.screen.height) /
        virtual_width;
      // 取得した倍率で拡大縮小する
      attributes["initial-scale"] = `${aspect}`;
    } catch {
      attributes = copyObject(DEFAULT_ATTRIBUTES);
    }
    // 設定値を反映する
    viewport.setAttribute("content", attributeToString(attributes));
  },
  data() {
    if (
      ValueMapper.map({
        "/error": true,
        "/login": true,
        "/tos": true,
      }).getOrElse(this.$route.path, false)
    ) {
      return {};
    }
    // トークンがある（ログイン済み）なら
    if (Account.isSignIn(this.$store)) {
      // ユーザー情報を取得する
      if ((this.$store.getters.userDisplayName || "").length == 0) {
        // ログインしているユーザーの情報を取得する
        Api.call("/admin/user", {
          purpose: "VIEW_SELF",
        })
          .then((users) => {
            // ユーザー情報を共通ストアに反映する
            Account.applyUserInfo(this.$store, users);
          })
          .catch((error) => {
            error.resolve();
          });
      }
    }
    return {};
  },
};
</script>

<style></style>
